import { Component, Input, Output, OnInit, EventEmitter } from '@angular/core';

import { File } from '@core/objects/file';
import { User } from '@core/objects/user';
import { Avatar } from '@core/objects/avatar';
import { AvatarsService } from '@core/services/avatars/avatars.service';

import { AppService } from '@app/services/app/app.service';
import { AvatarService } from '@app/services/app/avatar.service';


/**
 * @deprecated we should use new app version since 12/10/2026
 */
@Component({
    selector: 'profile-avatar-main',
    templateUrl: './main.component.html',
    styleUrls: ['./main.component.scss']
})
export class ProfileAvatarMainComponent implements OnInit{

    public readonly STATUS_NONE = 0;
    public readonly STATUS_ERROR_UPLOAD = 1;

    public readonly VIEW_MAIN   = "main";
    public readonly VIEW_UPLOAD = "upload";
    public readonly VIEW_EDIT   = "edit";

    @Input() user: User;
    @Output() clickCancel = new EventEmitter();

    public view: string = this.VIEW_MAIN;
    public file: File = null;
    public options: any = {};
    private backupOptions: any = {};
    // public defaultAvatar: boolean = true;
    public status: number = this.STATUS_NONE;

	constructor(private appSrv: AppService, private avatarGetSrv: AvatarsService, private avatar: AvatarService){}

	ngOnInit(){
        // get file from user avatar
        if(this.user.avatar != null){
            this.file = this.user.avatar.file;
            this.options = this.user.avatar.options;
            this.backupOptions = {...this.options}
            // this.defaultAvatar = false;
        }
    }

    show(area: string) {
        this.view = area;
    }

    cancel() {
        // console.log("cancel");
        this.clickCancel.emit();
        this.options = {...this.backupOptions};
    }

    delete() {
        // TODO: check what to do after this call.
        this.avatar.deleteAvatar$().subscribe(() => {
            // console.debug(" data from call",data);
            this.file = null;
            this.options = {};

            this.avatarGetSrv.reload(this.user);
            this.appSrv.init();
        });
    }

    saveOption(options: any) {
        // check avatar uplaoded response when fails.
        this.avatar.saveAvatar$(this.file.id, options).subscribe({
            next: (avatar: Avatar) => {
                if (!avatar || !avatar.file) {
                    this.status = this.STATUS_ERROR_UPLOAD;
                    return;
                }
                this.avatarGetSrv.reload(this.user);
                this.appSrv.init();
                this.file = avatar.file;
                this.options = avatar.options;
                this.backupOptions = {...avatar.options};

                this.view = this.VIEW_MAIN;
                this.status = this.STATUS_NONE;
            },
            error: (error: any) => {
                this.status = this.STATUS_ERROR_UPLOAD;
            }
        });
    }

    cancelOption() {
        // console.log("cancel option");
        this.file = this.user.avatar != null? this.user.avatar.file : null;
        this.view = this.VIEW_MAIN;
        this.options = {...this.backupOptions};
    }

    uploadFile(file: File) {
        // console.log("upload file");
        this.file = file;
        this.view = this.VIEW_EDIT;
        // this.backupOptions = {...this.options};
        this.options = {};
    }


    dismissError() {
        this.status = this.STATUS_NONE;
        this.cancelOption();
    }

}
